<div class="header-container">
  <div class="container">
    <div class="row">
      <div class="col-12 header-column">
        <div class="navigation">
          <nav class="navbar">
            <div class="navbar-logo">
              <img src="/assets/razzl_logo_text.png" routerLink="/home" alt="Razzl text logo" />
            </div>
            <div class="navbar-nav desktop-only">
              <a
                class="nav-item"
                [routerLink]="['/home']"
                [class.active]="router.isActive('/home', false)"
                *ngIf="
                  rootStore.userStore.userData?.role !== userRoleEnum.Client
                "
                >Home</a
              >
              <a
                class="nav-item"
                [routerLink]="['/team', getActiveProject()]"
                [class.active]="router.isActive('/team', false)"
                >Team</a
              >
              <a
                class="nav-item player"
                [routerLink]="['/player', getActivePlayer()]"
                [class.active]="router.isActive('/player', false)"
                *ngIf="
                  rootStore.userStore.userData?.role !== userRoleEnum.Client
                "
                >Player</a
              >
              <a
                class="nav-item finance"
                [routerLink]="['/finances']"
                routerLinkActive="active"
                *ngIf="rootStore.userStore.userData?.role === userRoleEnum.Admin"
                >Finances</a
              >
            </div>
          </nav>
        </div>

        <div class="dropdown desktop-only" *ngIf="rootStore.userStore.userData">
          <div class="top-profile-wrapper">
            <div class="organization-dropdown" #orgDropdownMenu>
              <div class="organization-name" (click)="toggleOrgDropdown()">{{ currentOrganization.name }}</div>
              <div class="list" *ngIf="orgDropdown">
                <ul>
                  <li
                    *ngFor="let organization of loginableOrganizations; let i = index"
                    [class.disabled]="organization.id === currentOrganization._id"
                    (click)="switchOrganization(organization.id)"
                  >
                    <div class="organization-container">
                      <img class="organization-image" [src]="organization.logo" *ngIf="organization.logo" />
                      <span>{{ organization.name }}</span>
                    </div>
                  </li>
                  <div class="line"></div>
                  <li (click)="orgSettings()">Settings</li>
                  <div class="line"></div>
                  <li (click)="createOrganization()">Create new workspace</li>
                </ul>
              </div>
            </div>

            <div #dropdownMenu class="user-dropdown">
              <div class="profile-icon" (click)="toggleDropdown()">
                <div class="image">
                  <img
                    class="profile-image"
                    *ngIf="rootStore.userStore.userData?.image"
                    [src]="rootStore.userStore.userData.image"
                    alt="Profile Image"
                  />
                  <span *ngIf="!rootStore.userStore.userData?.image">
                    {{ rootStore.userStore.userData | getInitials }}
                  </span>
                </div>
              </div>
              <div class="list" *ngIf="dropdown">
                <ul>
                  <li class="disabled" (click)="userSettings()">
                    {{ rootStore.userStore.userData?.firstName }} {{ rootStore.userStore.userData?.lastName }}
                  </li>
                  <div class="line"></div>
                  <li (click)="userSettings()">Settings</li>
                  <div class="line"></div>
                  <li (click)="logout()" class="font-weight-bold">Logout</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="hamburger mobile-only" (click)="toggleMobileMenu()" [class.opened]="isMobileMenuOpen">
          <div class="line"></div>
        </div>
        <!--
        <a class="top-profile-wrapper" [routerLink]="['options']">
          <div class="top-profile-image">
            <span class="top-profile-image-short">Pr</span>
          </div>
          <p class="top-profile-name" *mobxAutorun>
            {{ rootStore.userStore.getUsername() }}
          </p>
        </a>
         -->
      </div>
    </div>
  </div>
</div>
<div class="navbar-nav-mobile mobile-only" *ngIf="isMobileMenuOpen">
  <div class="container">
    <div class="nav-mobile-items">
      <a
        class="nav-item"
        [routerLink]="['/home']"
        (click)="hideMobileMenu()"
        *ngIf="rootStore.userStore.userData?.role !== userRoleEnum.Client"
        >Home</a
      >
      <a class="nav-item" [routerLink]="['/team', getActiveProject()]" (click)="hideMobileMenu()">Team</a>
      <a
        class="nav-item player"
        [routerLink]="['/player', getActivePlayer()]"
        (click)="hideMobileMenu()"
        *ngIf="rootStore.userStore.userData?.role !== userRoleEnum.Client"
        >Player</a
      >
      <a
        class="nav-item finance"
        [routerLink]="['/finances']"
        routerLinkActive="active"
        (click)="hideMobileMenu()"
        *ngIf="rootStore.userStore.userData?.role === userRoleEnum.Admin"
        >Finances</a
      >
      <a
        class="nav-item options"
        [routerLink]="['/options']"
        routerLinkActive="active"
        (click)="hideMobileMenu()"
        *ngIf="rootStore.userStore.userData?.role === userRoleEnum.Admin"
        >Settings</a
      >
      <hr />
      <div class="nav-item" (click)="userSettings(); hideMobileMenu()">Profile</div>
      <select class="select-organization" (change)="switchOrganization($event.target['value'])">
        <option value="" selected hidden>Switch workspace</option>
        <option
          [value]="organization.id"
          *ngFor="let organization of loginableOrganizations"
          [disabled]="
            organization.id ===
            rootStore.userStore.userData.currentOrganization._id
          "
        >
          {{ organization.name }}
        </option>
      </select>
      <div class="nav-item" (click)="logout(); hideMobileMenu()">Logout</div>
    </div>
  </div>
</div>
<div class="expiration-warning" *ngIf="trialExpirationWarning">
  <div class="container">
    <strong>Dear {{ rootStore.userStore.userData.firstName || "Razzl user" }}!</strong>
    We've noticed that your free trial is about to expire in
    <strong *ngIf="trialExpirationDays && !trialExpirationHours">
      {{ trialExpirationDays }} day{{ trialExpirationDays === 1 ? "" : "s" }}.</strong
    >
    <strong *ngIf="trialExpirationHours"
      >{{ trialExpirationHours }} hour{{ trialExpirationHours === 1 ? "" : "s" }}.</strong
    >
    <strong *ngIf="trialExpirationHours === 0">anytime now.</strong>
    We recommend you take a look at our billing plan options and find something that suits you and your team.
  </div>

  <div class="close-btn" (click)="hideExpirationWarning()">x</div>
</div>
<div class="expiration-warning expired" *ngIf="trialExpiredWarning">
  <div class="container">
    <strong>Dear {{ rootStore.userStore.userData.firstName || "Razzl user" }}!</strong>
    Your trial has expired and all accounts are now with limited functionality. Please contact your organization admin
    to update the billing details.
  </div>
</div>

<div *ngIf="switchingOrganization" class="switching-org-loader">
  Switching organization

  <div style="position: relative; margin-left: -75px">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
